import React from 'react';
import { Checkbox as ShadcnCheckbox } from '@lb-classroom/ui';

interface CheckboxProps {
  id: string | number;
  updateHandler: (id: string | number) => void;
  inlineLabel?: string;
  wrapperClass?: string;
  isChecked?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const {
    id,
    updateHandler,
    inlineLabel,
    wrapperClass = 'text-right mr-2',
    isChecked,
  } = props;

  const handleChange = () => {
    updateHandler(id);
  };

  return (
    <label className={`${wrapperClass} flex items-center gap-2 cursor-pointer`}>
      <ShadcnCheckbox
        checked={isChecked}
        onCheckedChange={handleChange}
        onClick={(e) => e.stopPropagation()}
      />
      {inlineLabel && <span className="font-bold">{inlineLabel}</span>}
    </label>
  );
};

export default Checkbox;
